// ISO50001Certification.jsx
import React from "react";

export default function ISO50001Certification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISO 50001 Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISO 50001 Energy Management Certification Support
          </h1>
          <div className="w-20 h-1 bg-blue-600 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in ISO 50001 Certification for energy
            management systems, helping organisations design and implement an
            EnMS aligned with ISO 50001:2018 so energy performance is managed
            systematically.[web:407][web:411]
          </p>
          <p className="text-gray-700">
            The service focuses on building policy, planning, operational
            control and monitoring elements so that energy data drives decisions
            and certification audits are supported with clear evidence.[web:402][web:409]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-blue-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/4597282/pexels-photo-4597282.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="City skyline with power lines symbolising energy management"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISO 50001 Certification
            </h2>
            <p className="text-gray-700 mb-4">
              ISO 50001 requires documented energy policy, planning, operational
              controls and records that demonstrate improved energy
              performance.[web:402][web:403]
            </p>
            <div className="bg-gray-50 border border-blue-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Energy policy approved by top management, stating commitments
                  to improved energy performance, availability of information
                  and compliance with applicable requirements.[web:403][web:409]
                </li>
                <li>
                  Energy consumption data and energy review documentation,
                  including significant energy uses, baselines, and energy
                  performance indicators (EnPIs).[web:402][web:403][web:408]
                </li>
                <li>
                  Business details and EnMS scope and boundaries, describing the
                  organisation, facilities covered and key energy‑using
                  processes.[web:403][web:409]
                </li>
                <li>
                  Objectives, targets, action plans and operational control
                  procedures, plus monitoring, measurement and internal audit
                  records that evidence implementation and improvement.[web:402][web:403][web:410]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The support is structured to turn ISO 50001 into a practical tool
              for reducing energy use and costs while meeting certification
              requirements.[web:411][web:409]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-blue-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Energy Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on interpreting ISO 50001 clauses, selecting EnPIs,
                  setting realistic baselines and integrating legal and other
                  requirements into the EnMS.[web:402][web:407]
                </p>
              </div>

              <div className="border-l-4 border-blue-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Stepwise help from energy review and documentation through
                  implementation, internal audits and preparation for
                  certification audits.[web:409][web:411]
                </p>
              </div>

              <div className="border-l-4 border-blue-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  Continued advisory to maintain the EnMS, respond to audit
                  findings and support surveillance and recertification
                  cycles.[web:403][web:410]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-blue-600 text-blue-700 font-medium hover:bg-blue-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
